import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  styled,
  Chip,
  IconButton,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useFetchUserByManagerQuery } from "../../../services/managerService";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from 'js-cookie';
import {
  useAddCommentsMutation,
  useFetchCommentsQuery,
  // useFetchReportHistoryQuery,
  // useFetchReportVersionQuery,
  useUpdateCommentsMutation,
} from "../../../services/user-reportService";
import { DataGrid } from "@mui/x-data-grid";


import {
  // useFetchCurrentUserQuery,
  useFetchOrgNameQuery,
  useResendEmailMutation,
} from "../../../services/profileService";
import "../../../styles.css";
import DownloadIcon from '@mui/icons-material/Download';
import ViewIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from "@mui/icons-material/Delete";
import { useFetchCurrentVersionQuery } from "../../../services/reportService";
import { toast, ToastContainer } from "react-toastify";
import apiClient from "../../../api/axios";
import HiddenReportGenerator from "./HiddenReportGenerator";

const ManagerDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const [selectedUserForReport, setSelectedUserForReport] = useState(null);
  const [reportVersions, setReportVersions] = useState([]);
  // const [comments, setComments] = useState([]);
  // const [reportsLoading, setReportsLoading] = useState(false);
  // const [selectedReportPdf, setSelectedReportPdf] = useState(null);
  const [editingComment, setEditingComment] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState("");
  const [selectedReportVersionId, setSelectedReportVersionId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isAddCommentDialogOpen, setIsAddCommentDialogOpen] = useState(false);
  const [newCommentText, setNewCommentText] = useState("");
  const [OrganizationName, setOrganizationName] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [generatingPdfFor, setGeneratingPdfFor] = useState(null);

  const { user } = useSelector((state) => state.auth);
  // const {
  //   data: currentUser,
  //   isLoading: isLoadingUser,
  //   refetch: fetch_currentuser,
  // } = useFetchCurrentUserQuery(selectedUserId, {
  //   skip: !selectedUserId, // Skip fetching if no ID is selected
  // });
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const managerId = user?.manager_id;
  const organizationId = user?.organization_id;
  const isSuperManager =
    user?.role === "manager" && Boolean(user?.super_manager ?? user?.is_owner);
  const { data: fetchOrg, refetch: fetch_org } = useFetchOrgNameQuery();

  // const { data: usebymanager, isLoading: usebymanagerLoading, refetch: use_manager } = useFetchUserByManagerQuery();

  const {
    data: usebymanager,

    refetch: use_manager,
  } = useFetchUserByManagerQuery(managerId, {
    skip: !managerId, // Skip fetching if no manager ID is available
  });
  const { refetch:fetch_currentVersion} = useFetchCurrentVersionQuery(selectedUserId, {
    skip: !selectedUserId,
  });

  
  
  // const {data: reportVersionsdata, refetch: fetch_versions } =
  //   useFetchReportVersionQuery(selectedUserId, {
  //     skip: !selectedUserId, // Skip fetching if no ID is selected
  //   });
  // const {
  //   data: reportVersionsdata,
  //   refetch: fetch_versions,
  //   isFetching,
  // } = useFetchReportVersionQuery(selectedUserId, {
  //   skip: !selectedUserId, // Skip fetching if no ID is selected
  // });

  const {
    data: commentsdata,

    refetch: fetching_comments,
  } = useFetchCommentsQuery(selectedUserId, {
    skip: !selectedUserId, // Skip fetching if no ID is selected
  });
  // const { data: reportReportHistories } = useFetchReportHistoryQuery(
  //   selectedUserId,
  //   {
  //     skip: !selectedUserId, // Skip fetching if no ID is selected
  //   }
  // );
  const usebymanagerArray = useMemo(() => {
    return Array.isArray(usebymanager?.data) ? usebymanager.data : [];
  }, [usebymanager]);
  // const usebymanagerArray = Array.isArray(usebymanager?.data)
  //   ? usebymanager?.data
  //   : [];
  // console.log("usebymanager error:", usebymanager.error);
  const [sendEmailWithToken] = useResendEmailMutation();
  const [addComment] = useAddCommentsMutation();
  const [updateComment] = useUpdateCommentsMutation();
  useEffect(() => {
    const fetchUsers = async () => {
      if (managerId) {
        try {
          setLoading(true);
          setUsers(usebymanagerArray);
          use_manager();
        } catch (err) {
          setError(err.response?.data?.detail || "Failed to fetch users");
        } finally {
          setLoading(false);
        }
      }
    };

    if (managerId) {
      fetchUsers();
    }
  }, [managerId, use_manager, usebymanager, usebymanagerArray]);
  useEffect(() => {
    fetch_org();

    console.log(fetchOrg);

    if (fetchOrg) {
      setOrganizationName(fetchOrg?.data?.organization_name); // Set organization name
    }
  }, [fetchOrg, fetch_org]);
  // useEffect(() => {
  //   console.log("Updated selectedUserId:", selectedUserId);
  // }, [selectedUserId]);

  // const fetchReportVersions = async (employee_Id) => {
  //   console.log("employee_Id", employee_Id);

  //   // setReportsLoading(true);
  //   setSelectedUserId(employee_Id);

  //   setSelectedUserForReport(employee_Id);
  //   setReportsLoading(true);
  //   try {
  //     console.log("Before API Call:", selectedUserId);
  //     console.log("Report Data:", reportVersionsdata);

  //     if (!reportVersionsdata) {
  //       console.log("hello");

  //       setReportVersions([]);
  //       return;
  //     }

  //     setComments(commentsdata || []);
  //   } catch (err) {
  //     console.error("API Error:", err.response?.status, err.response?.data);
  //     setError(
  //       err.response?.data?.detail ||
  //         `Failed to fetch report versions and comments (Error ${err.response?.status})`
  //     );
  //   } finally {
  //     setReportsLoading(false);
  //   }
  // };
  // const reportVersionsArray = Array.isArray(reportVersionsdata?.data)
  //   ? reportVersionsdata.data
  //   : [];
  const commentsArray = Array.isArray(commentsdata?.data)
    ? commentsdata.data
    : [];
  // const reportReportHistoriesArray = Array.isArray(
  //   reportReportHistories?.data?.report_history
  // )
  //   ? reportReportHistories?.data?.report_history
  //   : [];
  // const emailHistoryArray = Array.isArray(
  //   reportReportHistories?.data?.email_history
  // )
  //   ? reportReportHistories?.data.email_history
  //   : [];

  // setReportVersions(reportVersionsArray);
  const mapCommentsToVersion = (versionId) => {
    if (!Array.isArray(commentsArray)) return [];
    return commentsArray.filter(
      (comment) => comment.report_version_id === versionId
    );
  };

  // const [anchorProfile, setAnchorProfile] = useState(null);
  // const [anchorNotification, setAnchorNotification] = useState(null);
  const [reportHistory, setReportHistory] = useState([]);
  const [emailHistory, setEmailHistory] = useState([]);

  // const openProfileMenu = Boolean(anchorProfile);
  // const openNotificationMenu = Boolean(anchorNotification);
  const [openHistory, setOpenHistory] = useState(false);
  const [openEmailHistory, setOpenEmailHistory] = useState(false);
  const [deletingReportVersionId, setDeletingReportVersionId] = useState(null);

  const [showDialog, setShowDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("info"); // Default to info
  const [userId, setUserId] = useState(null);
  const [openManagerLoginInfo, setOpenManagerLoginInfo] = useState(false);
  const [selectedManagerRow, setSelectedManagerRow] = useState(null);
  const [openManagerChangePassword, setOpenManagerChangePassword] = useState(false);
  const [changePasswordEmail, setChangePasswordEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [changingPassword, setChangingPassword] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // const filteredUsers = searchQuery
  // ? users.filter((user) =>
  //     user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     user.email.includes(searchQuery.toLowerCase()) ||
  //     user.job_title.toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // : users;
  const filteredUsers = searchQuery
    ? (users || []).filter(
        (user) =>
          (user?.name?.toLowerCase() || "").includes(searchQuery) ||
          (user?.email?.toLowerCase() || "").includes(searchQuery) ||
          (user?.job_title?.toLowerCase() || "").includes(searchQuery) ||
          (user?.role?.toLowerCase() || "").includes(searchQuery)
      )
    : users || [];

  const handleOpenManagerChangePassword = (managerRow) => {
    const email = managerRow?.email;
    if (!email) {
      toast.error("Manager email not found.");
      return;
    }
    setChangePasswordEmail(email);
    setNewPassword("");
    setConfirmNewPassword("");
    setOpenManagerChangePassword(true);
  };

  const handleCloseManagerChangePassword = () => {
    if (changingPassword) return;
    setOpenManagerChangePassword(false);
    setChangePasswordEmail("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const handleSubmitManagerChangePassword = async () => {
    const email = String(changePasswordEmail || "").trim();
    if (!email) {
      toast.error("Manager email not found.");
      return;
    }
    if (!newPassword || !confirmNewPassword) {
      toast.error("Please enter password and confirm password.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      toast.error("Password and confirm password must match.");
      return;
    }

    setChangingPassword(true);
    try {
      const payload = {
        email,
        password: newPassword,
        confirm_password: confirmNewPassword,
      };
      const resp = await apiClient.put("/profile/change-password", payload);
      toast.success(resp?.data?.message || "Password updated successfully");
      handleCloseManagerChangePassword();
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message || "Failed to update password.");
    } finally {
      setChangingPassword(false);
    }
  };

  const handleOpenManagerLoginInfo = (managerRow) => {
    setSelectedManagerRow(managerRow || null);
    setOpenManagerLoginInfo(true);
  };

  const handleCloseManagerLoginInfo = () => {
    setOpenManagerLoginInfo(false);
    setSelectedManagerRow(null);
  };
  // const [openPDF, setOpenPDF] = useState(false);
  const fetchReportVersions = async (employee_Id) => {
    console.log("employee_Id", employee_Id);

    // Clear previous report versions immediately to avoid stale state issues
    setReportVersions([]);

    // Set the selected user
    setSelectedUserId(employee_Id);
    setSelectedUserForReport(employee_Id);

    // Show loading state
    // setReportsLoading(true);

    try {
      console.log("Fetching data for:", employee_Id);
      
      // Call the API to get report versions
      // const response = await fetch(`http://0.0.0.0:8000/report/reports/${employee_Id}/versions`);
      const response = await fetch(
        `${API_BASE_URL}report/reports/${employee_Id}/versions`
      );
      console.log(response);
      if (response.status === 401) {
        // Token expired, handle logout or refresh
        console.error("Session expired. Redirecting to login...");
        navigate("/"); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error(`API Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      console.log("API Response:", data);

      // Ensure reportVersions is an array
      if (Array.isArray(data) && data.length > 0) {
        setReportVersions(data);
      } else {
        console.log("No reports found.");
        setReportVersions([]); // Show no rows available
      }

      // Set comments if available
      // setComments(commentsdata || []);
    } catch (err) {
      console.error("API Error:", err);

      // Instead of showing an error message, clear data to show "No rows available"
      setReportVersions([]);

      // Do not set an error message (prevents UI from displaying errors)
      // setError(`Failed to fetch report versions and comments (Error ${err.response?.status || err.message})`);
    } finally {
      // setReportsLoading(false);
    }
  };

  const handleHistoryClick = (userId) => {
    // setOpenHistory(true);
    console.log(userId);
    setSelectedUserId(userId); // Set the selected user ID
    setOpenHistory(true);
    fetchHistoryData(userId);

    // Fetch data when opening
  };


  // const handleResendEmailClick = async (userId) => {
  //   const confirmation = window.confirm("Are you sure you want to send the email?");

  //   if (!confirmation) {
  //     return;
  //   }

  //   try {
  //     // Call the resendEmail mutation
  //     const response = await sendEmailWithToken(userId).unwrap();
  //     console.log("Email Resend Response:", response);

  //     // Show success alert
  //     alert("Email has been successfully sent to the user.");
  //   } catch (error) {
  //     console.error("Error resending email:", error);
  //     alert("Failed to send email.");
  //   }
  // };
  const handleResendEmailClick = (id) => {
    setUserId(id);

    setDialogMessage("Are you sure you want to resend the email?");
    setDialogType("confirmation"); // Set type to 'confirmation'
    setShowDialog(true);
  };

  const confirmResendEmail = async () => {
    setShowDialog(false);

    try {
      const response = await sendEmailWithToken(userId).unwrap();
      console.log("Email Resend Response:", response);

      setDialogMessage("Email has been successfully sent to the user.");
      setDialogType("success");
      setShowDialog(true);
    } catch (error) {
      console.error("Error resending email:", error);
      setDialogMessage("Failed to send email.");
      setDialogType("error");
      setShowDialog(true);
    }
  };

  const closeDialog = () => {
    setShowDialog(false);
  };

  const cancelResendEmail = () => {
    setShowDialog(false);
  };

  const handleEmailHistoryClick = (userId) => {
    setOpenEmailHistory(true);
    // console.log(userId);
    setSelectedUserId(userId); // Set the selected user ID
    setOpenEmailHistory(true);
    fetchHistoryData(userId);

    // Fetch data when opening
  };

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };
  const handleCloseEmailHistory = () => {
    setOpenEmailHistory(false);
  };
  const access_token = Cookies.get('auth_token')
  // console.log(access_token);
  
  const fetchHistoryData = async (userId) => {
  
    try {
     
      // const response = await fetch(
      //   `${API_BASE_URL}history/report_history/${userId}/versions`
      // );
      // const sources = reportReportHistoriesArray;
      const response = await fetch(
        `${API_BASE_URL}history/report_history/${userId}/versions`,
        {
          headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json'
          },
          credentials: 'include' // Include this if needed (e.g., for cookies)
        }
      );
      
      const data = await response.json();
      console.log("Fetched data:", data);
      
      // setReportHistory(reportReportHistoriesArray || []);
      // setEmailHistory(emailHistoryArray || []);
      console.log(data.report_history)
      setReportHistory(data.report_history || []);
      setEmailHistory(data.email_history || []);
      // setReportHistory(response.data.report_history);
      // console.log(reportHistory)
      // const newreportHistory=response.data.report_history
      // console.log(newreportHistory)
      // setEmailHistory(response.data.email_history);
    } catch (error) {
      console.error("Error fetching history data:", error);
    }
  };
  const handleAddEmployeeClick = () => {
    navigate("/create-employee"); // Replace '/create-employee' with the appropriate route for creating a new employee
  };
  const handleAddManagerClick = () => {
    navigate("/create-manager"); // Replace '/create-employee' with the appropriate route for creating a new employee
  };

  const handleAddCommentClick = (userId, reportVersionId) => {
    setSelectedUserId(userId);
    setSelectedReportVersionId(reportVersionId);
    setIsAddCommentDialogOpen(true);
  };

  const handleSubmitNewComment = async () => {
    // console.log("Submitting new comment:", {
    //   comment_text: newCommentText,
    //   user_id: selectedUserId,
    //   report_version_id: selectedReportVersionId,
    // });
    try {
       await addComment({
        comment_text: newCommentText,
        user_id: selectedUserId,
        report_version_id: selectedReportVersionId,
      });

      setIsAddCommentDialogOpen(false);
      setNewCommentText("");
      fetching_comments();
      // Clear the input field
    } catch (err) {
      console.error("Failed to add comment:", err);
    }
  };

  const handleEditClick = (
    commentId,
    commentText,
    selectedUserId,
    reportVersionId
  ) => {
    setEditingComment(commentId);
    setEditedCommentText(commentText);
    setSelectedUserId(selectedUserId);
    setSelectedReportVersionId(reportVersionId);
  };

  const handleSaveEdit = async () => {
    console.log(selectedReportVersionId);

    try {
      await updateComment({
        // comment_id: editingComment,
        comment_text: editedCommentText,
        user_id: selectedUserId,
        report_version_id: editingComment,
      }).unwrap();
      setEditingComment(null); // Exit edit mode
      setEditedCommentText("");
      fetching_comments(); // Clear the input field
    } catch (err) {
      console.error("Failed to update comment:", err);
      // Optionally, show a user-friendly error message
    }
  };

  const handleViewPdf = async (userId, pdfPath) => {
    // Open a blank tab immediately so popup blockers don't block it later
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write("Loading PDF...");
    }

    try {
      const AZURE_BASE =
        process.env.REACT_APP_AZURE_BLOB_BASE_URL ||
        "https://activehrsaprod.blob.core.windows.net/activatehrpdf";

      if (!pdfPath) {
        if (newWindow) newWindow.close();
        toast.info(
          "No PDF found for this version. Regenerating automatically in the background, please wait..."
        );
        setGeneratingPdfFor({ userId, action: "view", pdfPath: null });
        return;
      }

      const pdfUrl = `${AZURE_BASE}/${pdfPath}`;

      let azureFileExists = false;
      try {
        const headResponse = await fetch(pdfUrl, { method: "HEAD" });
        azureFileExists = headResponse.ok;
      } catch {
        azureFileExists = true; // Fallback if CORS blocks HEAD
      }

      if (!azureFileExists) {
        if (newWindow) newWindow.close();
        toast.info(
          "PDF file missing from storage. Regenerating automatically in the background, please wait..."
        );
        setGeneratingPdfFor({ userId, action: "view", pdfPath });
        return;
      }

      // PDF is valid, update the new window's location to the PDF URL
      if (newWindow) {
        newWindow.location.href = pdfUrl;
      } else {
        // Fallback if the initial window.open was blocked (unlikely, but possible)
        window.open(pdfUrl, "_blank");
      }
    } catch (error) {
      if (newWindow) newWindow.close();
      console.error("Error checking PDF:", error);
      toast.error("Error opening PDF");
    }
  };
  // const handleCloseOpenPDF = () => {
  //   setOpenPDF(false);
  // };
  

  const handleDownloadClick = (userId) => {
    console.log(userId,"userId");
    
    console.log("shouldFetch",shouldFetch);
    
    setSelectedUserId(userId);
    console.log("selectedUserId",selectedUserId);
    setShouldFetch(true);
    // handleDownload(userId);
  };
  // useEffect(() => {
  //   if (shouldFetch && selectedUserId !== null) {
  //     console.log("Fetching data for userId:", selectedUserId);
  //     handleDownload(selectedUserId);
  //     setShouldFetch(false); // Reset shouldFetch after handling
  //   }
  // }, [shouldFetch, selectedUserId]);
  useEffect(() => {
    if (shouldFetch && selectedUserId !== null) {
      console.log("Fetching data for userId:", selectedUserId);

      const fetchReport = async (userId) => {
        try {
          setLoading(true);
          console.log("Fetching current version for userId:", userId);

          const result = await fetch_currentVersion(userId).unwrap();
          console.log(result, "result");

          const AZURE_BASE =
            process.env.REACT_APP_AZURE_BLOB_BASE_URL ||
            "https://activehrsaprod.blob.core.windows.net/activatehrpdf";

          // CASE 1: No pdf_path in DB — report has never been generated
          if (!result?.data?.pdf_path) {
            toast.info(
              "No PDF found for this user. Regenerating automatically in the background, please wait..."
            );
            setGeneratingPdfFor({ userId, action: "download", pdfPath: null });
            return;
          }

          const pdfUrl = `${AZURE_BASE}/${result.data.pdf_path}`;

          // CASE 2: pdf_path exists in DB — validate the file actually exists in Azure
          let azureFileExists = false;
          try {
            const headResponse = await fetch(pdfUrl, { method: "HEAD" });
            azureFileExists = headResponse.ok;
          } catch {
            // HEAD blocked by CORS — fall back to assuming file might exist
            // We will confirm when we do the GET below
            azureFileExists = true;
          }

          if (!azureFileExists) {
            // File record in DB but blob missing from Azure — regenerate
            toast.info(
              "PDF file missing from storage. Regenerating automatically in the background, please wait..."
            );
            setGeneratingPdfFor({ userId, action: "download", pdfPath: result.data.pdf_path });
            return;
          }

          // CASE 3: PDF is valid — download it
          const response = await fetch(pdfUrl);

          if (!response.ok) {
            // GET also failed — file truly missing
            toast.info(
              "PDF file missing from storage. Regenerating automatically in the background, please wait..."
            );
            setGeneratingPdfFor({ userId, action: "download", pdfPath: result.data.pdf_path });
            return;
          }

          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          // Use only the filename, not the full path
          const fileName = result.data.pdf_path.split("/").pop();
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
          toast.success("PDF downloaded successfully!");
        } catch (error) {
          console.error("Error fetching report:", error);
          toast.error(
            error.message || "Error fetching report. Please try again."
          );
        } finally {
          setLoading(false);
        }
      };

      fetchReport(selectedUserId);
      setShouldFetch(false);
    }
  }, [shouldFetch, selectedUserId, fetch_currentVersion, navigate]);
  // const handleDownload = async (userId) => {
  //   try{
  //     setLoading(true);
  //   console.log(userId);
  //   const result = await fetch_currentVersion(userId).unwrap();
  //   console.log(result,"result");
  //   // setShouldFetch(true);
  //   if(shouldFetch){
  //     const result = await fetch_currentVersion(userId).unwrap();
  //     console.log("result",result);
      
    
  //     if (result && result?.data?.pdf_path) {
  //       // const pdfUrl = `https://activate-pdfstorage.s3.ap-southeast-2.amazonaws.com/${result?.data?.pdf_path}`;
  //       const pdfUrl = `https://activehrsa.blob.core.windows.net/activatehrpdf/${result?.data?.pdf_path}`;
        
  //       const response = await fetch(pdfUrl);
  //       const blob = await response.blob();

  //     // Create a temporary URL for the blob
  //       const blobUrl = window.URL.createObjectURL(blob);
        
  //       // Create a temporary anchor element
  //       const link = document.createElement('a');
  //       link.href = blobUrl;
  //       link.setAttribute('download', result.data.pdf_path); // Set the download attribute with the filename

  //       // Append the anchor to the document body
  //       document.body.appendChild(link);

  //       // Programmatically trigger a click on the anchor to start the download
  //       link.click();

  //       // Remove the anchor from the document
  //       document.body.removeChild(link);

  //       // Revoke the blob URL
  //       window.URL.revokeObjectURL(blobUrl);
  //       // const link = document.createElement('a');
  //       // link.href = pdfUrl;
  //       // link.setAttribute('download', result?.data?.pdf_path);
  //       // document.body.appendChild(link);
  //       // link.click();
  //       // document.body.removeChild(link);
  //     } else if (error) {
  //       toast.error(error.message || 'Error fetching report. Please try again.');
  //     }
  //   }
  // }catch (error) {
  //   console.error('Error fetching report:', error);
  //   // Display a toast notification with the error message
  //   toast.error(error.message || 'Error fetching report. Please try again.');
  // }
  // finally {
  //   setLoading(false); // Hide loading spinner
  // }
  //   // Wait for the query to fetch data
   

  
    
  // };
  
  

  const handleEditUser = (userId) => {
    // setSelectedUserForEdit(userId);
    setSelectedUserForReport(null);
    navigate(`/user_details-stepss/${userId}`);
  };

  const handleViewReportsClick = (userId) => {
    console.log(userId);

    // setSelectedUserForReport(userId);

    // setSelectedUserForEdit(null);
    fetchReportVersions(userId);
  };

  const handleDeleteReportVersion = async (employeeId, reportId, versionId) => {
    if (!employeeId || !reportId || !versionId) {
      toast.error("Missing employee id, report id, or version id.");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this report version?"
    );
    if (!confirmed) return;

    setDeletingReportVersionId(versionId);
    try {
      const resp = await apiClient.delete(
        `/report/reports/${reportId}/versions/${versionId}`
      );
      toast.success(
        resp?.data?.detail || "Report version deleted successfully"
      );

      // Refresh list to keep version numbers / ordering consistent
      await fetchReportVersions(employeeId);
    } catch (e) {
      toast.error(
        e?.response?.data?.detail ||
          e?.response?.data?.message ||
          e?.message ||
          "Failed to delete report version."
      );
    } finally {
      setDeletingReportVersionId(null);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    const errorMessage = error?.detail || "An error occurred";
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6" color="error">
          {errorMessage}
        </Typography>
      </Box>
    );
  }

  const columns = [
    // {
    //   field: "id",
    //   headerName: "ID",
    //   width: 100,
    // },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 250,

    },
    {
      field: "job_title",
      headerName: "Job Title",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "role", // Add role field here
      headerName: "Role", // Column header for role
      flex: 1,
      minWidth: 150,
    },
    {
      field: "updated_at",
      headerName: "Last Modified",
      flex: 1,
      minWidth: 200,
      type: "dateTime",
      valueGetter: (value) => {
        if (!value) return null;
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      },
      renderCell: (params) => {
        const d = params.value;
        if (!(d instanceof Date) || Number.isNaN(d.getTime())) return "—";
        return d.toLocaleString("en-US", {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      sortComparator: (v1, v2) => {
        const a =
          v1 instanceof Date && !Number.isNaN(v1.getTime()) ? v1.getTime() : 0;
        const b =
          v2 instanceof Date && !Number.isNaN(v2.getTime()) ? v2.getTime() : 0;
        return a - b;
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 420,
      sortable: false,
      renderCell: (params) => {
        const data = params.row.id;
        return (
          <>
            <CustomBtn
              sx={{ background: "#1085AB", borderColor: "#1085AB" }}
              onClick={() => handleViewReportsClick(data)}
            >
              <ViewIcon fontSize="inherit" />
            </CustomBtn>
            <CustomBtn onClick={() => handleEditUser(data)}>
              <EditIcon fontSize="inherit" />
            </CustomBtn>
            <CustomBtn sx={{ background: "#1065AB", borderColor: "#1065AB" }}
            onClick={() => handleDownloadClick(data)}>
              <DownloadIcon fontSize="inherit" />
            </CustomBtn>
            {isSuperManager && (
              <>
                <CustomBtn
                  sx={{ background: "#1085AB", borderColor: "#1085AB" }}
                  onClick={() => handleOpenManagerLoginInfo(params.row)}
                >
                  Login Info
                </CustomBtn>
                <CustomBtn
                  sx={{ background: "#d32f2f", borderColor: "#d32f2f" }}
                  disabled={changingPassword}
                  onClick={() => handleOpenManagerChangePassword(params.row)}
                >
                  Change Password
                </CustomBtn>
              </>
            )}
          </>
        );
      },
    },
    {
      field: "otheraction",
      headerName: "",
      flex: 1,
      minWidth: 500,
      sortable: false,
      renderCell: (params) => {
        const data = params.row.id;
        return (
          <>
            <CustomBtn
              sx={{ background: "#1085AB", borderColor: "#1085AB" }}
              onClick={() => handleHistoryClick(data)}
            >
              Report Versions
            </CustomBtn>
            <CustomBtn onClick={() => handleEmailHistoryClick(data)}>
              Email History
            </CustomBtn>
            <CustomBtn
              sx={{ background: "#1065AB", borderColor: "#1065AB" }}
              onClick={() => handleResendEmailClick(data)}
            >
              Send roleReview
            </CustomBtn>
          </>
        );
      },
    },
  ];

  // Managers table removed; super managers can act from the main users table.
  const reportVersions_data = [
    {
      field: "version_number",
      headerName: "Version Number",
      width: 200,
    },
    {
      field: "Content",
      headerName: "Content",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        const content = params.row.content;
        if (!content || Object.keys(content).length === 0) {
          return <Typography variant="body2">No content available</Typography>;
        }
        return (
          <>
            <table width="100%" className="data-table-wrap">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Title</th>
                  <th>Job Summary</th>
                  <th>Area</th>
                  <th>Importance</th>
                  <th>Time Spent</th>
                  <th>Activity Area</th>
                  <th>Activity Time Spent</th>
                </tr>
              </thead>
              <tbody>
                {content?.core_focus_areas?.map((area, idx) => (
                  <React.Fragment key={idx}>
                    {area.critical_activities?.map((activity, activityIdx) => (
                      <tr key={activityIdx}>
                        {activityIdx === 0 && (
                          <>
                            {idx === 0 && (
                              <>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.name || "N/A"}
                                </td>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.title || "N/A"}
                                </td>
                                <td
                                  rowSpan={content.core_focus_areas.reduce(
                                    (sum, area) =>
                                      sum +
                                      (area.critical_activities?.length || 1),
                                    0
                                  )}
                                >
                                  {content?.role_review?.job_summary || "N/A"}
                                </td>
                              </>
                            )}
                            <td rowSpan={area.critical_activities.length}>
                              {area.area || "N/A"}
                            </td>
                            <td rowSpan={area.critical_activities.length}>
                              {(area.importance !== null &&
                              area.importance !== undefined
                                ? area.importance
                                : "N/A") + "%"}
                            </td>
                            <td rowSpan={area.critical_activities.length}>
                              {(area.time_spent !== null &&
                              area.time_spent !== undefined
                                ? area.time_spent
                                : "N/A") + "%"}
                            </td>
                          </>
                        )}
                        <td>{activity.area || "N/A"}</td>
                        <td>
                          {(activity.importance !== null &&
                          activity.importance !== undefined
                            ? activity.importance
                            : "N/A") + "%"}
                        </td>
                      </tr>
                    ))}
                    {(!area.critical_activities ||
                      area.critical_activities.length === 0) && (
                      <tr>
                        {idx === 0 && (
                          <>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.name || "N/A"}
                            </td>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.title || "N/A"}
                            </td>
                            <td rowSpan={content.core_focus_areas.length}>
                              {content?.role_review?.job_summary || "N/A"}
                            </td>
                          </>
                        )}
                        <td>{area.area || "N/A"}</td>
                        <td>
                          {(area.importance !== null &&
                          area.importance !== undefined
                            ? area.importance
                            : "N/A") + "%"}
                        </td>
                        <td>
                          {(area.time_spent !== null &&
                          area.time_spent !== undefined
                            ? area.time_spent
                            : "N/A") + "%"}
                        </td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </>
        );
      },
    },
  ];
  const emailHistory_data = [
    {
      field: "subject",
      headerName: "Subject",
      width: 180,
    },
    {
      field: "body",
      headerName: "Body",
      flex: 1,
      minWidth: 350,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        let chipColor;
        if (params.value === "failed") {
          chipColor = "error";
        } else if (params.value === "pending") {
          chipColor = "warning";
        } else if (params.value === "sent") {
          chipColor = "success";
        }
        return <Chip label={params.value} color={chipColor} size="small" />;
      },
    },
    {
      field: "sent_at",
      headerName: "Sent At",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const date = new Date(params.row.sent_at);

        // Options for toLocaleDateString to format as MM/DD/YYYY
        const options = {
          year: "2-digit", // Use 'numeric' for 4-digit year. '2-digit' for 2-digit
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };

        return date.toLocaleDateString("en-US", options); // Format the date
      },
    },
  ];
  const reportVersions_data2 = [
    {
      field: "version_number",
      headerName: "Version Number",
      width: 200,
    },
    {
      field: "comments",
      headerName: "Comments",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        const versionId =
          params?.row?.id ??
          params?.row?.version_id ??
          params?.row?.report_version_id ??
          params?.row?.version_number;
        const versionComments = mapCommentsToVersion(versionId);
        return (
          <Box>
            {versionComments.length > 0 ? (
              versionComments.map((comment) => (
                <Box key={comment.id} sx={{ position: "relative" }}>
                  {comment.comment_text}
                  <CustomBtn3
                    onClick={() =>
                      handleEditClick(
                        comment.id,
                        comment.comment_text,
                        selectedUserForReport,
                        versionId
                      )
                    }
                  >
                    <EditIcon fontSize="inherit" />
                  </CustomBtn3>
                </Box>
              ))
            ) : (
              <Box key={versionComments.id} sx={{ position: "relative" }}>
                No comments available
                <CustomBtn3
                  onClick={() =>
                    handleAddCommentClick(selectedUserForReport, versionId)
                  }
                >
                  <AddIcon fontSize="inherit" />
                </CustomBtn3>
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 420,
      renderCell: (params) => {
        const employeeId = selectedUserForReport;
        const reportId = params?.row?.report_id;
        const versionId =
          params?.row?.id ??
          params?.row?.version_id ??
          params?.row?.report_version_id ??
          params?.row?.version_number;
        const isDeleting = deletingReportVersionId === versionId;
        return (
          <>
            <CustomBtn2
              sx={{ background: "#1085AB", borderColor: "#1085AB" }}
              size="small"
              onClick={() => handleViewPdf(employeeId, params.row.pdf_path)}
            >
              View Report
            </CustomBtn2>
            <CustomBtn2
              sx={{ background: "#d32f2f", borderColor: "#d32f2f" }}
              size="small"
              disabled={isDeleting}
              onClick={() =>
                handleDeleteReportVersion(employeeId, reportId, versionId)
              }
              startIcon={<DeleteIcon fontSize="inherit" />}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </CustomBtn2>
          </>
        );
      },
    },
  ];

  return (
    <>
      <ToastContainer />

      {/* Hidden Report Generator and its Overlay */}
      {generatingPdfFor && (
        <>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 9999,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={60} sx={{ color: "#1085AB", mb: 2 }} />
            <Typography variant="h6" color="textSecondary">
              Regenerating PDF Report...
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Please wait, this will take a few seconds.
            </Typography>
          </Box>
          <HiddenReportGenerator
            userId={generatingPdfFor.userId}
            action={generatingPdfFor.action}
            existingPdfPath={generatingPdfFor.pdfPath}
            onComplete={(success) => {
              setGeneratingPdfFor(null);
              if (success) {
                toast.success(
                  `PDF generated and ${
                    generatingPdfFor.action === "view" ? "opened" : "downloaded"
                  } successfully.`
                );
              }
            }}
          />
        </>
      )}

      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap sx={{ marginBottom: "10px" }}>
            <Col12Wrap>
              <TitleWrap
                sx={{ textTransform: "capitalize", marginBottom: "0" }}
              >
                {OrganizationName}
              </TitleWrap>
            </Col12Wrap>
          </RowWrap>
          <RowWrap sx={{ marginBottom: "20px", alignItems: "center" }}>
            <Col6Wrap>
              <CustomBtn
                sx={{
                  padding: "7px 10px",
                  "& .MuiButton-icon": { marginRight: "3px", marginLeft: "0" },
                }}
                startIcon={<AddIcon />}
                onClick={handleAddEmployeeClick}
              >
                Role Review
              </CustomBtn>
              <CustomBtn
                sx={{
                  padding: "7px 10px",
                  background: "#1085AB",
                  borderColor: "#1085AB",
                  "& .MuiButton-icon": { marginRight: "3px", marginLeft: "0" },
                }}
                startIcon={<AddIcon />}
                onClick={handleAddManagerClick}
              >
                Add Manager
              </CustomBtn>
            </Col6Wrap>
            <Col6Wrap>
              <FormGroupWrap>
                <CustomTextField
                  variant="outlined"
                  placeholder="Search by Name,Email,Job title & Role"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </FormGroupWrap>
            </Col6Wrap>
          </RowWrap>
          <RowWrap>
            <Col12Wrap>
              <TableContentwrap>
                <DataGrid
                  rows={filteredUsers}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 30,
                      },
                    },
                  }}
                  pageSizeOptions={[30]}
                  disableRowSelectionOnClick
                  disableColumnMenu={true}
                  columnVisibilityModel={{ name: true }}
                  sx={{
                    "& .MuiDataGrid-iconButtonContainer": {
                      visibility: 'visible !important',
                      width: 'auto !important',
                      "svg": {
                        opacity:'1 !important',
                      }
                    } 
                  }}
                />
              </TableContentwrap>
            </Col12Wrap>
          </RowWrap>

        </ContainerWrap>
      </SectionWrap>

      <Dialog
        open={openManagerLoginInfo}
        onClose={handleCloseManagerLoginInfo}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ paddingRight: "48px" }}>
          Login Info
          <IconButton
            aria-label="close"
            onClick={handleCloseManagerLoginInfo}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "grid", gap: 2 }}>
            <TextField
              label="Name"
              value={selectedManagerRow?.name || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
            <TextField
              label="Login Email"
              value={selectedManagerRow?.email || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
            <TextField
              label="Job Title"
              value={selectedManagerRow?.job_title || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
            <TextField
              label="Organization ID"
              value={selectedManagerRow?.organization_id ?? organizationId ?? ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
            <TextField
              label="Role"
              value={selectedManagerRow?.role || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseManagerLoginInfo}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openManagerChangePassword}
        onClose={handleCloseManagerChangePassword}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ paddingRight: "48px" }}>
          Change Password
          <IconButton
            aria-label="close"
            onClick={handleCloseManagerChangePassword}
            disabled={changingPassword}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "grid", gap: 2 }}>
            <TextField
              label="Email"
              value={changePasswordEmail}
              InputProps={{ readOnly: true }}
              fullWidth
            />
            <TextField
              label="Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
            />
            <TextField
              label="Confirm Password"
              type="password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseManagerChangePassword} disabled={changingPassword}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmitManagerChangePassword}
            disabled={changingPassword}
            sx={{ background: "#1085AB" }}
          >
            {changingPassword ? "Saving..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Report Versions Btn */}
      <Dialog
        open={openHistory}
        onClose={handleCloseHistory}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          //   onClick={handleClose}
          // onClick={handleCloseHistory}
          onClick={handleCloseHistory}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitleWrap>Report Versions</DialogTitleWrap>
        <DialogContentWrap>
          <DataGrid
            sx={{ "& .MuiDataGrid-cell": { padding: "20px 10px" } }}
            rows={reportHistory.length > 0 ? reportHistory : []}
            columns={reportVersions_data}
            getRowId={(row) => row.version_number}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 1,
                },
              },
            }}
            pageSizeOptions={[1]}
            disableRowSelectionOnClick
            disableColumnMenu={true}
            getRowHeight={() => "auto"}
            localeText={{ noRowsLabel: "No rows available" }}
          />
        </DialogContentWrap>
      </Dialog>
      {/* Email History Btn */}
      <Dialog
        open={openEmailHistory}
        onClose={handleCloseEmailHistory}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          //   onClick={handleClose}
          // onClick={handleCloseHistory}
          onClick={handleCloseEmailHistory}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitleWrap>Email History</DialogTitleWrap>
        <DialogContentWrap>
          <DataGrid
            rows={emailHistory.length > 0 ? emailHistory : []}
            columns={emailHistory_data}
            getRowId={(row) => row.sent_at}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 30,
                },
              },
            }}
            pageSizeOptions={[30]}
            disableRowSelectionOnClick
            disableColumnMenu={true}
            localeText={{ noRowsLabel: "No rows available" }}
          />
        </DialogContentWrap>
      </Dialog>
      {/* Report Versions */}
      <Dialog
        open={!!selectedUserForReport}
        onClose={() => setSelectedUserForReport(null)}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          //   onClick={handleClose}
          // onClick={handleCloseHistory}
          onClick={() => setSelectedUserForReport(null)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitleWrap>Report Versions</DialogTitleWrap>
        <DialogContentWrap>
          <DataGrid
            // rows={reportVersionsArray}
            rows={reportVersions.length > 0 ? reportVersions : []}
            columns={reportVersions_data2}
            getRowId={(row) =>
              row?.id ??
              row?.version_id ??
              row?.report_version_id ??
              row?.version_number
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 30,
                },
              },
            }}
            pageSizeOptions={[30]}
            disableRowSelectionOnClick
            disableColumnMenu={true}
            localeText={{ noRowsLabel: "No rows available" }}
          />
        </DialogContentWrap>
      </Dialog>
      {/* View Pdf */}
      {/* Edit Comment */}
      <Dialog
        open={editingComment !== null}
        onClose={() => setEditingComment(null)}
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <DialogTitleWrap>Edit Comment</DialogTitleWrap>
        <DialogContentWrap>
          <TextField
            fullWidth
            placeholder="Comment"
            multiline
            rows={4}
            value={editedCommentText}
            onChange={(e) => setEditedCommentText(e.target.value)}
            sx={{
              width: "100%",
              border: "1px solid #DADADA",
              borderRadius: "7px",
              "& .MuiInputBase-formControl": {
                padding: "0",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: "300",
                lineHeight: "1",
                color: "#2C2C2E",
                padding: "14px 20px",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          />
        </DialogContentWrap>
        <DialogActionsWrap>
          <CustomCancelBtn onClick={() => setEditingComment(null)}>
            Cancel
          </CustomCancelBtn>
          <CustomBtnSave onClick={handleSaveEdit}>Save</CustomBtnSave>
        </DialogActionsWrap>
      </Dialog>
      {/* Add Comment */}
      <Dialog
        open={isAddCommentDialogOpen}
        onClose={() => setIsAddCommentDialogOpen(false)}
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <DialogTitleWrap>Add Comment</DialogTitleWrap>
        <DialogContentWrap>
          <TextField
            fullWidth
            placeholder="Comment"
            multiline
            rows={4}
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
            sx={{
              width: "100%",
              border: "1px solid #DADADA",
              borderRadius: "7px",
              "& .MuiInputBase-formControl": {
                padding: "0",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: "300",
                lineHeight: "1",
                color: "#2C2C2E",
                padding: "14px 20px",
              },
              "& fieldset": {
                border: "none",
              },
            }}
          />
        </DialogContentWrap>
        <DialogActionsWrap>
          <CustomCancelBtn onClick={() => setIsAddCommentDialogOpen(false)}>
            Cancel
          </CustomCancelBtn>
          <CustomBtnSave onClick={handleSubmitNewComment}>Submit</CustomBtnSave>
        </DialogActionsWrap>
      </Dialog>
      {/* Alert Dialog */}
      <Dialog
        open={showDialog}
        onClose={closeDialog}
        fullWidth
        maxWidth="sm"
        sx={{
          textAlign: "center",
          "& .MuiDialog-paper": {
            padding: "30px",
          },
        }}
      >
        <DialogTitleWrap>{dialogMessage}</DialogTitleWrap>
        <DialogActionsWrap sx={{ justifyContent: "center" }}>
          {dialogType === "confirmation" ? (
            <>
              <CustomCancelBtn onClick={cancelResendEmail}>
                Disagree
              </CustomCancelBtn>
              <CustomBtnSave onClick={confirmResendEmail}>Agree</CustomBtnSave>
            </>
          ) : (
            <CustomBtnSave onClick={closeDialog}>Close</CustomBtnSave>
          )}
        </DialogActionsWrap>
      </Dialog>
    </>
  );
};

export default ManagerDashboard;

const FormGroupWrap = styled(Box)(() => ({
  maxWidth: "420px",
  marginLeft: "auto",
  marginBottom: "0px",
  position: "relative",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
  },
}));
const CustomTextField = styled(TextField)(() => ({
  width: "99%",
  border: "1px solid #DADADA",
  background: "#ffffff",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#333333",
    padding: "10px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "50%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
    marginTop: "10px",
    marginBottom: "10px",
  },
}));
const TableContentwrap = styled(Box)(() => ({
  padding: "15px",
  background: "#ffffff",
  borderRadius: "7px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "28px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
}));
const CustomBtn = styled(Button)(() => ({
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "10px",
  margin: "0 5px",
  boxShadow: "none !important",
}));
const DialogTitleWrap = styled(DialogTitle)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
  padding: "0",
}));
const DialogContentWrap = styled(DialogContent)(() => ({
  marginBottom: "15px",
  padding: "0",
}));
const CustomBtn2 = styled(Button)(() => ({
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "10px",
  margin: "0 5px",
  boxShadow: "none !important",
}));
const CustomBtn3 = styled(Button)(() => ({
  position: "absolute",
  top: "50%",
  right: "0",
  transform: "translateY(-50%)",
  minWidth: "auto",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "5px",
  padding: "5px",
  margin: "0 5px",
  boxShadow: "none !important",
}));
const DialogActionsWrap = styled(DialogActions)(() => ({
  padding: "0",
}));
const CustomCancelBtn = styled(Button)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#d32f2f",
  borderColor: "#d32f2f",
  borderRadius: "10px",
  padding: "13px 20px",
  boxShadow: "none !important",
}));
const CustomBtnSave = styled(Button)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#1085AB",
  borderColor: "#1085AB",
  borderRadius: "10px",
  padding: "13px 20px",
  boxShadow: "none !important",
}));
